module.exports = __webpack_public_path__ + "27b01c840da1e4df5e12a34470226cad.svg";